import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isString } from 'lodash';
import classnames from 'classnames';
import { TextField } from '@src/components/TextField';
import SectionTitle from '@src/components/SectionTitle';
import './styles.scss';

const withoutLineBreaks = str => {
  const re = /\n/g;
  return str.replace(re, '');
};

const countLineBreaks = str => {
  return (str.match(/\n/g) || '').length;
};

export default class DescriptionField extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    defaultValue: PropTypes.string,
    fullWidth: PropTypes.bool,
    info: PropTypes.node,
    inputClassName: PropTypes.string,
    invalid: PropTypes.bool,
    label: PropTypes.string,
    maxLength: PropTypes.number,
    message: PropTypes.string,
    minLength: PropTypes.number,
    onBlur: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    textFieldWrapperClassName: PropTypes.string,
    title: PropTypes.node.isRequired,
    titleSize: PropTypes.string,
  };

  state = {
    limitReached: false,
    valueLength: withoutLineBreaks(this.props.defaultValue || '').length,
  };

  // Count value length without line breaks but send original value to the server.
  onChange = value => {
    const { maxLength, onChange } = this.props;
    const activeValue = withoutLineBreaks(value);

    if (!maxLength || (maxLength && maxLength >= activeValue.length)) {
      this.setState({ valueLength: activeValue.length });
      onChange(value);
    } else if (!this.state.limitReached) {
      this.setState({ valueLength: maxLength });
      // In case user pastes big string.
      onChange(value.substring(0, maxLength + countLineBreaks(value)));
    }
  };

  onKeyDown = e => {
    // Set limit reached as a true before onChange event happens
    if (this.props.maxLength && withoutLineBreaks(e.target.value).length === this.props.maxLength) {
      this.setState({ limitReached: true });
    }
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.defaultValue !== nextProps.defaultValue) {
      const valueLength = nextProps.defaultValue ? withoutLineBreaks(nextProps.defaultValue).length : 0;
      this.setState({
        limitReached: nextProps.maxLength && valueLength === nextProps.maxLength,
        valueLength,
      });
    }
  }

  render() {
    const {
      label,
      placeholder,
      fullWidth,
      message,
      maxLength,
      minLength,
      title,
      info,
      invalid,
      defaultValue,
      className,
      titleSize,
      textFieldWrapperClassName,
      inputClassName,
      onBlur,
    } = this.props;
    const { valueLength } = this.state;

    return (
      <div className={classnames('description-field', className)}>
        <div className="description-field-content">
          <div className="description-field-content-header">
            {isString(title) ? <SectionTitle size={titleSize} title={title} /> : title}

            <span className="description-field-content-header-count">
              {valueLength}
              {maxLength ? ` / ${maxLength}` : ''}
            </span>
          </div>

          <TextField
            defaultValue={defaultValue}
            fullWidth={fullWidth}
            inputClassName={classnames('description-field__text-field', inputClassName)}
            label={label}
            message={message}
            messageType={invalid && 'error'}
            min={minLength}
            multiline
            onBlur={onBlur}
            onChange={this.onChange}
            onKeyDown={this.onKeyDown}
            placeholder={placeholder}
            wrapperClassName={classnames('description-field__text-field-wrapper', textFieldWrapperClassName)}
          />
        </div>

        {!!info && <div className="description-field-info">{info}</div>}
      </div>
    );
  }
}
